import clsx from "clsx";
import React from "react";

export default function SectionHeading({ className, children, ...restProps }) {
  return (
    <h2
      className={clsx("tw-text-lg tw-font-bold tw-text-primary-light tw-mb-2", className)}
      {...restProps}
    >
      {children}
    </h2>
  );
}
